import type { Kind, Tier } from "@/api/types";

/** Marker size multiplier per tier (lightweight-charts marker `size`). */
export const TIER_SIZE: Record<Tier, number> = { none: 0.6, small: 1, big: 1.6, whale: 2.4 };

/** Glyph per tier — information never by color alone. */
export const TIER_GLYPH: Record<Tier, string> = { none: "·", small: "•", big: "●", whale: "◆" };

export const TIER_LABEL: Record<Tier, string> = { none: "none", small: "small", big: "big", whale: "whale" };

/** Pixel radius for scatter/marker rendering. */
export function tierRadius(tier: Tier, base = 3): number {
  return base * TIER_SIZE[tier];
}

export const KIND_GLYPH: Record<Kind, string> = {
  buy: "▲",
  sell: "▼",
  send: "→",
  receive: "←",
  mint: "+",
  burn: "−",
  add_liquidity: "◇+",
  remove_liquidity: "◇−",
  collect_fees: "◇$",
};

export const KIND_LABEL: Record<Kind, string> = {
  buy: "BUY",
  sell: "SELL",
  send: "SEND",
  receive: "RECEIVE",
  mint: "MINT",
  burn: "BURN",
  add_liquidity: "ADD LIQ",
  remove_liquidity: "REMOVE LIQ",
  collect_fees: "COLLECT",
};

export const LIQUIDITY_KINDS: readonly Kind[] = ["add_liquidity", "remove_liquidity", "collect_fees"];
export const TRADE_KINDS: readonly Kind[] = ["buy", "sell"];
